export const createCookie = (name: string, value: string, days: number): void => {
    let expires;
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    } else {
        expires = '';
    }

    document.cookie = `${name}=${value} ${expires}; path=/; SameSite=Strict`;
};

export const readCookie = (name: string): string | null => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

export const eraseCookie = (name: string): void => {
    createCookie(name, '', -1);
};
